export default function () {
  return Math.max(this.maxScaling, this._computedMinScaling)
}
